import React from 'react';
import ColouredStyledButton from '../components/ColouredStyledButton';

const Footer: React.FC = () => {
  return (
    <footer className="footer bg-gray-100">
      <div className="padding-global px-5">
        <div className="padding-section-large py-20">
          <div className="container-large max-w-6xl mx-auto">
            <div className="footer_wrapper grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Left Column */}
              <div className="footer_col is-left flex flex-col space-y-8 pr-8">
                <div className="clutch-widget">
                  <iframe
                    id="iframe-0.43836438197231775"
                    width="100%"
                    src="https://widget.clutch.co/widgets/get/2?ref_domain=speargrowth.com&amp;uid=1248105&amp;rel_nofollow=true&amp;ref_path=/"
                    height="45px"
                    scrolling="no"
                    style={{ border: 'none', overflow: 'hidden', display: 'block', height: '44px' }}
                    title="Clutch Widget"
                  ></iframe>
                </div>
                <div className="flex-grow flex items-center">
                  <ColouredStyledButton 
                    onClick={() => window.location.href = 'https://speargrowth.com/'}
                  >
                    Back to Home Page →
                  </ColouredStyledButton>
                </div>
              </div>

              {/* Right Column */}
              <div className="footer_col is-right grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Services */}
                <div className="footer_col-card">
                  <div className="text-size-medium text-pink-600 font-semibold">Services</div>
                  <div className="footer_col-card-inside flex flex-col space-y-2 mt-4">
                    <a href="https://speargrowth.com/performance-marketing" className="footer_link text-gray-600 hover:text-pink-600 transition-all">Paid media</a>
                    <a href="https://speargrowth.com/seo-enablement" className="footer_link text-gray-600 hover:text-pink-600 transition-all">SEO Enablement</a>
                    <a href="https://speargrowth.com/saas-ppc-agency" className="footer_link text-gray-600 hover:text-pink-600 transition-all">SaaS PPC Agency</a>
                  </div>
                </div>

                {/* Resources */}
                <div className="footer_col-card">
                  <div className="text-size-medium text-pink-600 font-semibold">Resources</div>
                  <div className="footer_col-card-inside flex flex-col space-y-2 mt-4">
                    <a href="https://speargrowth.com/blog" className="footer_link text-gray-600 hover:text-pink-600 transition-all">Blog</a>
                    <a href="https://speargrowth.com/case-study" className="footer_link text-gray-600 hover:text-pink-600 transition-all">Case Studies</a>
                  </div>
                </div>

                {/* Company */}
                <div className="footer_col-card">
                  <div className="text-size-medium text-pink-600 font-semibold">Company</div>
                  <div className="footer_col-card-inside flex flex-col space-y-2 mt-4">
                    <a href="https://speargrowth.com/about-us" className="footer_link text-gray-600 hover:text-pink-600 transition-all">About Us</a>
                    <a
                      href="https://clutch.co/profile/spear-growth#summary"
                      rel="nofollow"
                      target="_blank"
                      className="footer_link text-gray-600 hover:text-pink-600 transition-all"
                    >
                      Client reviews
                    </a>
                    <a href="https://speargrowth.com/wall-of-appreciation" className="footer_link text-gray-600 hover:text-pink-600 transition-all">Our Supporters</a>
                  </div>
                </div>

                {/* Socials */}
                <div className="footer_col-card">
                  <div className="text-size-medium text-pink-600 font-semibold">Socials</div>
                  <div className="footer_col-card-inside flex flex-col space-y-2 mt-4">
                    <a
                      href="https://www.youtube.com/channel/UCJ4jBzjcmWYtSDAcYIDUkQQ"
                      target="_blank"
                      className="footer_col-card-social flex items-center space-x-2 text-gray-600 hover:text-pink-600 transition-all"
                    >
                      <div className="icon-embed-xsmall w-6 h-6">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M23.2801 6.50346C23.0184 5.51804 22.2473 4.74196 21.2682 4.47858C19.4937 4 12.3778 4 12.3778 4C12.3778 4 5.26196 4 3.48733 4.47858C2.50829 4.742 1.73721 5.51804 1.4755 6.50346C1 8.28958 1 12.0162 1 12.0162C1 12.0162 1 15.7427 1.4755 17.5289C1.73721 18.5143 2.50829 19.258 3.48733 19.5214C5.26196 20 12.3778 20 12.3778 20C12.3778 20 19.4936 20 21.2682 19.5214C22.2473 19.258 23.0184 18.5143 23.2801 17.5289C23.7556 15.7428 23.7556 12.0162 23.7556 12.0162C23.7556 12.0162 23.7556 8.28958 23.2801 6.50346V6.50346ZM10.0505 15.3996V8.63271L15.998 12.0162L10.0505 15.3996V15.3996Z" fill="currentColor"></path>
                        </svg>
                      </div>
                      <div>Youtube</div>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/spear-growth"
                      target="_blank"
                      className="footer_col-card-social flex items-center space-x-2 text-gray-600 hover:text-pink-600 transition-all"
                    >
                      <div className="icon-embed-xsmall w-6 h-6">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M20.5714 2H3.42411C2.63839 2 2 2.64732 2 3.44196V20.558C2 21.3527 2.63839 22 3.42411 22H20.5714C21.3571 22 22 21.3527 22 20.558V3.44196C22 2.64732 21.3571 2 20.5714 2ZM8.04464 19.1429H5.08036V9.59821H8.04911V19.1429H8.04464ZM6.5625 8.29464C5.61161 8.29464 4.84375 7.52232 4.84375 6.57589C4.84375 5.62946 5.61161 4.85714 6.5625 4.85714C7.50893 4.85714 8.28125 5.62946 8.28125 6.57589C8.28125 7.52679 7.51339 8.29464 6.5625 8.29464ZM19.1562 19.1429H16.192V14.5C16.192 13.3929 16.1696 11.9687 14.6518 11.9687C13.1071 11.9687 12.8705 13.1741 12.8705 14.4196V19.1429H9.90625V9.59821H12.75V10.9018H12.7902C13.1875 10.1518 14.1562 9.36161 15.5982 9.36161C18.5982 9.36161 19.1562 11.3393 19.1562 13.9107V19.1429Z" fill="currentColor"></path>
                        </svg>
                      </div>
                      <div>Linkedin</div>
                    </a>
                  </div>
                </div>

                {/* Location */}
                <div className="footer_col-card">
                  <div className="text-size-medium text-pink-600 font-semibold">Location</div>
                  <div className="footer_col-card-inside is-address mt-4">
                    <div className="footer_link text-gray-600">990, Sector 7, HSR Layout, Bengaluru, Karnataka 560102</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer_bottom bg-pink-600 rounded-lg flex justify-between items-center mt-20 p-4">
              <div className="footer_bottom-left flex space-x-5">
                <a href="https://speargrowth.com/terms-of-services" className="footer_bottom-link text-white">Terms & Conditions</a>
                <a href="https://speargrowth.com/privacy-policy" className="footer_bottom-link text-white">Privacy Policy</a>
              </div>
              <div className="footer_bottom-right">
                <div className="footer_bottom-text text-white">Copyright © 2024 Spear Growth All Rights Reserved</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;